import { debug } from './debugging';

/**
 * Returns the url of the forwarding fallback page that provides
 * country selection functionality.
 */
export function getHostName() {
  let url = '';

  if (typeof window !== 'undefined') {
    url = window.location.href;
  }

  try {
    return new URL(url).hostname;
  } catch (error) {
    if (error instanceof Error) {
      debug(`getHostName(): ${error} (url=${url})`);
    }
    return '';
  }
}
